import React from 'react';
import { Header, Footer } from '../../components';
import { useSearchParams, Link } from 'react-router-dom';

// After Stripe Checkout success, subscription is active (or incomplete if SCA required).
// User still needs to verify email & set password. session_id used if you want to pull session details later.

function SignupSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  return (
    <div className="signup-success-page">
      <Header />
      <main style={{ maxWidth: 720, margin: '0 auto', padding: '64px 24px' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '12px' }}>Payment Received</h1>
        <p style={{ fontSize: '1rem', lineHeight: 1.5, color: 'var(--text-secondary)', marginBottom: '24px' }}>
          Thanks for choosing a plan. We sent a verification email to the address you used during checkout. Please check your inbox (and spam folder) to verify your email and finish setting up your account.
        </p>
        {sessionId && (
          <div style={{ fontSize: '.75rem', color: 'var(--text-muted)', marginBottom: '24px' }}>
            Session reference: <code>{sessionId}</code>
          </div>
        )}
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          <Link to="/login" className="login-link" style={{ fontWeight: 600 }}>Go to Sign In</Link>
          <Link to="/" className="login-link" style={{ fontWeight: 600 }}>Return Home</Link>
        </div>
        <div style={{ marginTop: '40px', fontSize: '.8rem', color: 'var(--text-muted)' }}>
          Didn’t get the email? <Link to="/forgot-password" className="login-link">Resend verification / reset</Link>.
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default SignupSuccessPage;
